<template>
  <div
    class="relative h-full pb-24 lg:pb-0 flex flex-col lg:flex-row overflow-y-auto scrollbar"
    :class="{ 'bg-accent-3-90': isHotspot }"
  >
    <div class="w-full lg:h-full lg:w-78 flex-none lg:bg-grey-1">
      <div class="bg-grey-1">
        <div v-if="!showSidebar" class="flex-a h-16 p-x">
          <Breadcrumbs :post="post" :location="location" :category="category" />
        </div>

        <h1
          id="focus-target"
          class="flex-a p-x py-4 min-h-16 b-b-secondary focus-b"
          v-html="post.title"
        />
      </div>

      <div v-if="post.description" class="bg-white p-x py-6">
        <p v-html="post.description" />
      </div>
    </div>

    <div
      class="w-full lg:flex-c lg:h-full lg:py-10vw lg:px-24 xl:py-6vw xxl:px-10vw xxl:py-5vw lg:overflow-y scrollbar"
      @click.self="$router.push({ name: $route.meta.back })"
    >
      <Component
        :is="component"
        v-if="component"
        :post="post"
        textcolor="text-white"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { capitalize } from '@/mixins'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
const Article = () => import('@/components/Article.vue')
const Gallery = () => import('@/components/Gallery.vue')
const Video = () => import('@/components/Video.vue')

export default {
  name: 'Media',

  components: {
    Article,
    Gallery,
    Video,
    Breadcrumbs
  },

  mixins: [capitalize],

  props: {
    category: {
      type: Object,
      default: () => {}
    },

    location: {
      type: Object,
      default: () => {}
    },

    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'showSidebar', 'showPager', 'isHotspot']),

    component() {
      const component = this.capitalize(this.post.type)
      if (component !== 'Category') {
        return component
      }
      return false
    }
  }
}
</script>
